// noinspection DuplicatedCode
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

// Helper function untuk mendapatkan user dengan safe access
const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch (error) {
    console.error("Error parsing user from localStorage:", error);
    return {};
  }
};

// Helper function untuk membuat headers yang konsisten
const getAuthHeaders = () => {
  const user = getUser();
  return {
    Authorization: "Bearer " + user.Token,
    Accept: "*/*",
  };
};

// Helper function untuk handle response dan error
const handleResponse = (response, thunkAPI) => {
  if (response.status === 200) {
    return response.data;
  } else {
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleError = (error, thunkAPI, context = "") => {
  console.log(`💥 [${context}] Error:`, error);
  return thunkAPI.rejectWithValue(
    error.response?.data || { message: "Network error" }
  );
};

// ✅ PERBAIKAN: API Function untuk GetKaryawanSelect
export const getKaryawanSelect = createAsyncThunk(
  "absensiTransaksi/getKaryawanSelect",
  async (search = "", thunkAPI) => {
    const user = getUser();
    if (!user.Token) {
      return thunkAPI.rejectWithValue({ message: "User not authenticated" });
    }

    const params = new URLSearchParams();
    if (search) params.append("search", search);

    const baseUrl =
      process.env.REACT_APP_API_URL || "http://192.168.212.226:5000/";
    const url = `${baseUrl}getKaryawanSelect?${params.toString()}`;

    console.log("🔍 [getKaryawanSelect] URL:", url);

    try {
      const response = await axios.get(url, {
        headers: getAuthHeaders(),
        timeout: 10000,
      });

      console.log("✅ [getKaryawanSelect] Response:", response.data);

      if (response.data && response.data.status === "Success") {
        return {
          data: response.data.data || [],
          count: response.data.count || 0,
          message: response.data.message || "Berhasil memuat data karyawan",
        };
      } else {
        return thunkAPI.rejectWithValue({
          message: response.data?.message || "Gagal memuat data karyawan",
        });
      }
    } catch (e) {
      console.log("💥 [getKaryawanSelect] Error:", e);

      if (e.code === "ECONNABORTED") {
        return thunkAPI.rejectWithValue({ message: "Request timeout" });
      } else if (e.response?.status === 404) {
        return thunkAPI.rejectWithValue({
          message: "Endpoint tidak ditemukan",
        });
      }

      return thunkAPI.rejectWithValue(
        e.response?.data || { message: e.message || "Network error" }
      );
    }
  }
);

// ✅ UPDATE: API Function untuk GetAbsensi dengan Pagination
export const getAbsensiTransaksi = createAsyncThunk(
  "absensiTransaksi/get",
  async (
    {
      nik,
      start_date,
      end_date,
      tipe_karyawan,
      kategori,
      page = 1,
      page_size = 10, // ✅ DEFAULT 10
    },
    thunkAPI
  ) => {
    const user = getUser();
    if (!user.Token) {
      return thunkAPI.rejectWithValue({ message: "User not authenticated" });
    }

    const params = new URLSearchParams();
    if (nik) params.append("nik", nik);
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (tipe_karyawan) params.append("tipe_karyawan", tipe_karyawan);
    // Filter dari klik kartu Rekap Kehadiran — lihat AbsensiPage.js.
    if (kategori) params.append("kategori", kategori);

    // ✅ PASTIKAN: Parameter pagination dikirim
    params.append("page", page);
    params.append("page_size", page_size);

    const url = `${
      process.env.REACT_APP_API_URL
    }getAbsensi?${params.toString()}`;

    console.log("🔍 [getAbsensiTransaksi] URL:", url);
    console.log("📊 [getAbsensiTransaksi] Pagination:", { page, page_size });

    try {
      const response = await axios.get(url, {
        headers: getAuthHeaders(),
      });

      console.log("✅ [getAbsensiTransaksi] Response:", response.data);

      // ✅ PERBAIKAN: Handle response structure dengan benar
      const responseData = response.data;

      // Jika response menggunakan struktur pagination
      if (responseData.data && typeof responseData.data === "object") {
        return {
          ...responseData,
          currentPage: page,
          pageSize: page_size,
        };
      }
      // Jika response array langsung (legacy)
      else if (Array.isArray(responseData.data)) {
        return {
          ...responseData,
          currentPage: page,
          pageSize: page_size,
          // Buat struktur pagination manual
          data: {
            data: responseData.data,
            total_count: responseData.data.length,
            total_pages: Math.ceil(responseData.data.length / page_size),
            current_page: page,
            has_next: page * page_size < responseData.data.length,
            has_prev: page > 1,
          },
        };
      }

      return handleResponse(response, thunkAPI);
    } catch (e) {
      return handleError(e, thunkAPI, "getAbsensiTransaksi");
    }
  }
);

// ✅ UPDATE: API Function untuk Load More Data (Infinite Scroll)
export const loadMoreAbsensi = createAsyncThunk(
  "absensiTransaksi/loadMore",
  async (
    { nik, start_date, end_date, tipe_karyawan, kategori, page = 1, page_size = 10 },
    thunkAPI
  ) => {
    const user = getUser();
    if (!user.Token) {
      return thunkAPI.rejectWithValue({ message: "User not authenticated" });
    }

    const params = new URLSearchParams();
    if (nik) params.append("nik", nik);
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (tipe_karyawan) params.append("tipe_karyawan", tipe_karyawan);
    if (kategori) params.append("kategori", kategori);

    params.append("page", page);
    params.append("page_size", page_size);

    const url = `${
      process.env.REACT_APP_API_URL
    }getAbsensi?${params.toString()}`;

    console.log("🔍 [loadMoreAbsensi] URL:", url);
    console.log("📊 [loadMoreAbsensi] Pagination:", { page, page_size });

    try {
      const response = await axios.get(url, {
        headers: getAuthHeaders(),
      });

      console.log("✅ [loadMoreAbsensi] Response:", response.data);

      const responseData = response.data;

      if (responseData.data && typeof responseData.data === "object") {
        return {
          ...responseData,
          currentPage: page,
          pageSize: page_size,
          isLoadMore: true,
        };
      }

      return handleResponse(response, thunkAPI);
    } catch (e) {
      return handleError(e, thunkAPI, "loadMoreAbsensi");
    }
  }
);

export const importAbsensiTransaksi = createAsyncThunk(
  "absensiTransaksi/import",
  async (excelFile, thunkAPI) => {
    const user = getUser();
    if (!user?.Token) {
      return thunkAPI.rejectWithValue({
        message: "User not authenticated",
      });
    }

    if (!excelFile) {
      return thunkAPI.rejectWithValue({
        message: "File tidak ditemukan",
      });
    }

    const validTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/octet-stream",
    ];

    const fileExtension = excelFile.name
      .toLowerCase()
      .slice(excelFile.name.lastIndexOf("."));
    const isValidExtension = [".xlsx", ".xls"].includes(fileExtension);
    const isValidType = validTypes.includes(excelFile.type) || !excelFile.type;

    if (!isValidExtension && !isValidType) {
      return thunkAPI.rejectWithValue({
        message: "Format file tidak valid. Harus file Excel (.xlsx, .xls)",
      });
    }

    const formData = new FormData();
    formData.append("excelFile", excelFile);

    const url = process.env.REACT_APP_API_URL + "importAbsensi";

    console.log("🔍 [importAbsensiTransaksi] URL:", url);

    try {
      const response = await axios.post(url, formData, {
        headers: {
          ...getAuthHeaders(),
          "Content-Type": "multipart/form-data",
        },
        timeout: 60000,
      });

      console.log("✅ [importAbsensiTransaksi] Response:", response);
      return handleResponse(response, thunkAPI);
    } catch (e) {
      console.log("💥 [importAbsensiTransaksi] Error:", e);

      let errorMessage = "Terjadi kesalahan jaringan";

      if (e.code === "ECONNABORTED") {
        errorMessage = "Timeout: Upload terlalu lama";
      } else if (e.response?.status === 403) {
        errorMessage = "Akses ditolak. Token mungkin expired";
      } else if (e.response?.status === 413) {
        errorMessage = "File terlalu besar";
      } else if (
        e.response?.data?.message?.includes("zip") ||
        e.response?.data?.message?.includes("Excel")
      ) {
        errorMessage = `Error file Excel: ${e.response.data.message}`;
      } else if (e.response?.data) {
        errorMessage =
          e.response.data.message || "Terjadi kesalahan pada server";
      } else if (e.request) {
        errorMessage = "Tidak dapat terhubung ke server";
      }

      return thunkAPI.rejectWithValue({
        message: errorMessage,
        ...(e.response?.data || {}),
      });
    }
  }
);

export const getAbsensiSummary = createAsyncThunk(
  "absensiTransaksi/getSummary",
  async ({ nik, start_date, end_date }, thunkAPI) => {
    const user = getUser();
    if (!user.Token) {
      return thunkAPI.rejectWithValue({ message: "User not authenticated" });
    }

    const params = new URLSearchParams();
    if (nik) params.append("nik", nik);
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);

    const url = `${
      process.env.REACT_APP_API_URL
    }getAbsensiSummary?${params.toString()}`;

    console.log("🔍 [getAbsensiSummary] URL:", url);

    try {
      const response = await axios.get(url, {
        headers: getAuthHeaders(),
      });

      console.log("✅ [getAbsensiSummary] Response:", response);
      return handleResponse(response, thunkAPI);
    } catch (e) {
      return handleError(e, thunkAPI, "getAbsensiSummary");
    }
  }
);

// absensiTransaksiSlice.js
export const downloadTemplateAbsensi = createAsyncThunk(
  "absensi/downloadTemplate",
  async (_, { rejectWithValue }) => {
    try {
      // Download file template dari public folder
      const response = await fetch("/templates/template_import_absensi.xlsx");

      if (!response.ok) {
        throw new Error("Template file not found");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "template_import_absensi.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { message: "Template Excel berhasil didownload" };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ✅ UPDATE: INIT State dengan struktur pagination
const initialState = {
  message: "",
  data: [],
  summary: {},
  karyawanOptions: [],

  // Pagination state
  pagination: {
    currentPage: 1,
    pageSize: 10, // ✅ DEFAULT 10
    totalCount: 0,
    totalPages: 0,
    hasNext: false,
    hasPrev: false,
  },

  // Loading states
  isGetFetching: false,
  isGetSuccess: false,
  isGetError: false,
  isLoadMoreFetching: false,
  isLoadMoreSuccess: false,
  isLoadMoreError: false,
  isImportFetching: false,
  isImportSuccess: false,
  isImportError: false,
  isSummaryFetching: false,
  isSummarySuccess: false,
  isSummaryError: false,
  isDownloadFetching: false,
  isDownloadSuccess: false,
  isDownloadError: false,
  isKaryawanSelectFetching: false,
  isKaryawanSelectSuccess: false,
  isKaryawanSelectError: false,

  // Error messages
  errorMessage: "",
  karyawanSelectErrorMessage: "",
  importResult: null,
};

// ✅ UPDATE: SLICES dengan extraReducers untuk pagination
export const absensiTransaksiSlice = createSlice({
  name: "absensiTransaksi",
  initialState,
  reducers: {
    clearAbsensiMessage: (state) => {
      state.message = "";
      state.errorMessage = "";
      state.karyawanSelectErrorMessage = "";
      state.isGetSuccess = false;
      state.isGetError = false;
      state.isLoadMoreSuccess = false;
      state.isLoadMoreError = false;
      state.isImportSuccess = false;
      state.isImportError = false;
      state.isSummarySuccess = false;
      state.isSummaryError = false;
      state.isDownloadSuccess = false;
      state.isDownloadError = false;
      state.isKaryawanSelectSuccess = false;
      state.isKaryawanSelectError = false;
    },
    clearKaryawanOptions: (state) => {
      state.karyawanOptions = [];
    },
    // ✅ TAMBAH: Reset pagination ketika filter berubah
    resetPagination: (state) => {
      state.pagination = {
        currentPage: 1,
        pageSize: 50,
        totalCount: 0,
        totalPages: 0,
        hasNext: false,
        hasPrev: false,
      };
      state.data = [];
    },
    // ✅ TAMBAH: Clear data ketika melakukan search baru
    clearAbsensiData: (state) => {
      state.data = [];
      state.pagination.currentPage = 1;
    },
    // ✅ TAMBAH: Set current page manually
    setCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get Karyawan Select
      .addCase(getKaryawanSelect.pending, (state) => {
        state.isKaryawanSelectFetching = true;
        state.isKaryawanSelectError = false;
        state.isKaryawanSelectSuccess = false;
        state.karyawanSelectErrorMessage = "";
        console.log("🔄 [SLICE] getKaryawanSelect pending...");
      })
      .addCase(getKaryawanSelect.fulfilled, (state, action) => {
        state.isKaryawanSelectFetching = false;
        state.isKaryawanSelectSuccess = true;

        const payload = action.payload;
        console.log("✅ [SLICE] getKaryawanSelect payload:", payload);

        if (payload?.data && Array.isArray(payload.data)) {
          state.karyawanOptions = payload.data;
          console.log(
            "✅ [SLICE] karyawanOptions set:",
            payload.data.length,
            "items"
          );
        } else {
          state.karyawanOptions = [];
          console.log("⚠️ [SLICE] No data found in payload");
        }

        state.message = payload?.message || "Berhasil memuat data karyawan";
      })
      .addCase(getKaryawanSelect.rejected, (state, action) => {
        state.isKaryawanSelectFetching = false;
        state.isKaryawanSelectError = true;
        state.karyawanSelectErrorMessage =
          action.payload?.message || "Gagal mengambil data karyawan";
        state.karyawanOptions = [];
        console.log("💥 [SLICE] getKaryawanSelect rejected:", action.payload);
      })
      // ✅ UPDATE: GET Absensi Data dengan pagination
      .addCase(getAbsensiTransaksi.pending, (state) => {
        state.isGetFetching = true;
        state.isGetError = false;
        state.isGetSuccess = false;
        state.errorMessage = "";
      })
      .addCase(getAbsensiTransaksi.fulfilled, (state, { payload }) => {
        state.isGetFetching = false;
        state.isGetSuccess = true;

        console.log("📦 [SLICE] getAbsensiTransaksi payload:", payload);

        // Handle data dengan pagination
        if (payload.data && typeof payload.data === "object") {
          // Jika response menggunakan struktur pagination
          if (payload.data.data && Array.isArray(payload.data.data)) {
            state.data = payload.data.data; // ✅ SIMPAN DATA BARU
            state.pagination = {
              currentPage:
                payload.currentPage || payload.data.current_page || 1,
              pageSize: payload.pageSize || payload.data.page_size || 10,
              totalCount: payload.data.total_count || 0,
              totalPages: payload.data.total_pages || 0,
              hasNext: payload.data.has_next || false,
              hasPrev: payload.data.has_prev || false,
            };
          } else {
            // Fallback untuk response tanpa pagination structure
            state.data = Array.isArray(payload.data) ? payload.data : [];
          }
        } else {
          // Fallback untuk response lama
          state.data = Array.isArray(payload.data) ? payload.data : [];
        }

        state.message = payload.message || "Berhasil memuat data absensi";
      })
      .addCase(getAbsensiTransaksi.rejected, (state, { payload }) => {
        state.isGetFetching = false;
        state.isGetError = true;
        state.errorMessage = payload?.message || "Gagal mengambil data absensi";
        state.data = [];
      })
      // ✅ TAMBAH: Load More Absensi
      .addCase(loadMoreAbsensi.pending, (state) => {
        state.isLoadMoreFetching = true;
        state.isLoadMoreError = false;
        state.isLoadMoreSuccess = false;
      })
      .addCase(loadMoreAbsensi.fulfilled, (state, { payload }) => {
        state.isLoadMoreFetching = false;
        state.isLoadMoreSuccess = true;

        console.log("📦 [SLICE] loadMoreAbsensi payload:", payload);

        // Append data baru ke data existing
        if (payload.data && typeof payload.data === "object") {
          if (payload.data.data && Array.isArray(payload.data.data)) {
            // ✅ APPEND DATA, JANGAN REPLACE
            state.data = [...state.data, ...payload.data.data];
            state.pagination = {
              currentPage:
                payload.currentPage || payload.data.current_page || 1,
              pageSize: payload.pageSize || payload.data.page_size || 10,
              totalCount: payload.data.total_count || 0,
              totalPages: payload.data.total_pages || 0,
              hasNext: payload.data.has_next || false,
              hasPrev: payload.data.has_prev || false,
            };
          }
        }

        state.message = payload.message || "Berhasil memuat data tambahan";
      })
      .addCase(loadMoreAbsensi.rejected, (state, { payload }) => {
        state.isLoadMoreFetching = false;
        state.isLoadMoreError = true;
        state.errorMessage = payload?.message || "Gagal memuat data tambahan";
      })
      // IMPORT Absensi
      .addCase(importAbsensiTransaksi.pending, (state) => {
        state.isImportFetching = true;
        state.isImportError = false;
        state.isImportSuccess = false;
      })
      .addCase(importAbsensiTransaksi.fulfilled, (state, { payload }) => {
        state.isImportFetching = false;
        state.isImportSuccess = true;
        state.importResult = payload.data;
        state.message = payload.message;
      })
      .addCase(importAbsensiTransaksi.rejected, (state, { payload }) => {
        state.isImportFetching = false;
        state.isImportError = true;
        state.errorMessage = payload?.message || "Gagal import data absensi";
        if (payload?.data) {
          state.importResult = payload.data;
        }
      })
      // GET Summary
      .addCase(getAbsensiSummary.pending, (state) => {
        state.isSummaryFetching = true;
        state.isSummaryError = false;
        state.isSummarySuccess = false;
      })
      .addCase(getAbsensiSummary.fulfilled, (state, { payload }) => {
        state.isSummaryFetching = false;
        state.isSummarySuccess = true;
        state.summary = payload.data || {};
        state.message = payload.message;
      })
      .addCase(getAbsensiSummary.rejected, (state, { payload }) => {
        state.isSummaryFetching = false;
        state.isSummaryError = true;
        state.errorMessage =
          payload?.message || "Gagal mengambil summary absensi";
      })
      // DOWNLOAD Template
      .addCase(downloadTemplateAbsensi.pending, (state) => {
        state.isDownloadFetching = true;
        state.isDownloadError = false;
        state.isDownloadSuccess = false;
      })
      .addCase(downloadTemplateAbsensi.fulfilled, (state, { payload }) => {
        state.isDownloadFetching = false;
        state.isDownloadSuccess = true;
        state.message = payload.message;
      })
      .addCase(downloadTemplateAbsensi.rejected, (state, { payload }) => {
        state.isDownloadFetching = false;
        state.isDownloadError = true;
        state.errorMessage = payload?.message || "Gagal download template";
      });
  },
});

// ✅ UPDATE: Export actions
export const {
  clearAbsensiMessage,
  clearKaryawanOptions,
  resetPagination,
  clearAbsensiData,
} = absensiTransaksiSlice.actions;

export const karyawanSelectSelector = (state) => {
  console.log("🔍 [SELECTOR] Full state keys:", Object.keys(state));

  const absensiState = state.absensiTransaksi || {};

  console.log("🔍 [SELECTOR] absensiTransaksi state:", {
    karyawanOptions: absensiState.karyawanOptions,
    isKaryawanSelectFetching: absensiState.isKaryawanSelectFetching,
    isKaryawanSelectSuccess: absensiState.isKaryawanSelectSuccess,
  });

  return {
    karyawanOptions: absensiState.karyawanOptions || [],
    isKaryawanSelectFetching: absensiState.isKaryawanSelectFetching || false,
    isKaryawanSelectSuccess: absensiState.isKaryawanSelectSuccess || false,
    isKaryawanSelectError: absensiState.isKaryawanSelectError || false,
    errorMessage: absensiState.karyawanSelectErrorMessage || "",
  };
};

// ✅ UPDATE: Selector untuk absensi transaksi dengan pagination
export const absensiTransaksiSelector = (state) => {
  const absensiState = state.absensiTransaksi || {};

  return {
    data: absensiState.data || [],
    summary: absensiState.summary || {},
    pagination: absensiState.pagination || {
      currentPage: 1,
      pageSize: 50,
      totalCount: 0,
      totalPages: 0,
      hasNext: false,
      hasPrev: false,
    },
    isGetFetching: absensiState.isGetFetching || false,
    isLoadMoreFetching: absensiState.isLoadMoreFetching || false,
    isImportFetching: absensiState.isImportFetching || false,
    isDownloadFetching: absensiState.isDownloadFetching || false,
    errorMessage: absensiState.errorMessage || "",
    message: absensiState.message || "",
    importResult: absensiState.importResult || null,
    hasMoreData: absensiState.pagination?.hasNext || false,
  };
};

export default absensiTransaksiSlice.reducer;
